import { render, staticRenderFns } from "./HouseholdCard.vue?vue&type=template&id=f853b38c&"
import script from "./HouseholdCard.vue?vue&type=script&lang=ts&"
export * from "./HouseholdCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports